// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1zuF4","actions":"GroupTable_actions__1DG2x","deleteModalFooter":"GroupTable_deleteModalFooter__2CCMS"};